import { render, staticRenderFns } from "./MSelectNews.vue?vue&type=template&id=357dcc83&"
import script from "./MSelectNews.vue?vue&type=script&lang=ts&"
export * from "./MSelectNews.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports